export default __webpack_public_path__ + "static/media/pictogramBeaconUtilityNonMains48.f5f75890.svg";